import { Outlet } from 'react-router-dom';

import { BaseLayout } from './common/layouts/index.ts';

import '@/common/styles/global.scss';

const AppLayout = () => {
  return (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  );
};

export { AppLayout };
